import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export default function SEO({
  title,
  description = 'Vigor Auto Repair Garage Dubai – Full-spectrum automotive service: diagnostics, maintenance, brakes, AC, engine & transmission repair.',
  canonical,
  keywords = 'car service dubai, auto repair dubai, car repair dubai, car ac service dubai, car diagnostics dubai',
  image = '/logo3.png',
  type = 'website',
  schema
}) {
  const fullTitle = title ? `${title} | Vigor Auto Repair Garage Dubai` : 'Vigor Auto Repair Garage Dubai | Car Service & Diagnostics';

  // Derive a reliable canonical: prefer explicit prop, else construct from known base + current pathname.
  const location = useLocation?.();
  const base = 'https://vigorautorepair.com';
  const derived = location ? `${base}${location.pathname || ''}` : (typeof window !== 'undefined' ? window.location.href : base);
  const canonicalUrl = canonical || derived;
  const toAbsoluteUrl = (path) => {
    if (!path) return `${base}/logo3.png`;
    if (/^https?:\/\//i.test(path)) return path;
    return `${base}${path.startsWith('/') ? path : `/${path}`}`;
  };
  const ogImage = toAbsoluteUrl(image);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={ogImage} />
      <link rel="canonical" href={canonicalUrl} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
